import { render } from "./EventCard.vue?vue&type=template&id=c0266faa&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"

import "./EventCard.vue?vue&type=style&index=0&id=c0266faa&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c0266faa"

export default script